import { render, staticRenderFns } from "./ImportAttributeListItem.vue?vue&type=template&id=3fbd2c2a&scoped=true"
import script from "./ImportAttributeListItem.vue?vue&type=script&lang=js"
export * from "./ImportAttributeListItem.vue?vue&type=script&lang=js"
import style0 from "./ImportAttributeListItem.vue?vue&type=style&index=0&id=3fbd2c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd2c2a",
  null
  
)

export default component.exports